import * as XLSX from "xlsx";

export const exportToExcel = (
  tableRef,
  filename = "untitled.xlsx",
  sheetName = "Sheet 1",
) => {
  const table = tableRef.current;
  const wb = XLSX.utils.table_to_book(table, { sheet: sheetName });
  XLSX.writeFile(wb, filename);
};

export const exportToExcelFromData = (
  data,
  filename = "untitled.xlsx",
  sheetName = "Sheet 1",
) => {
  const ws = XLSX.utils.json_to_sheet(data, { skipHeader: false });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename);
};
